import { render, staticRenderFns } from "./ClientProfileChart.vue?vue&type=template&id=06c9f37e&scoped=true&"
import script from "./ClientProfileChart.vue?vue&type=script&lang=js&"
export * from "./ClientProfileChart.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileChart.vue?vue&type=style&index=0&id=06c9f37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9f37e",
  null
  
)

export default component.exports